export default __webpack_public_path__ + "static/Blitz10 01F38FE9-3fc3e423d972c30992b2004fbec20b54.jpg";